<topo-dialog
  [dialogRef]="dialogRef"
  hideHeaderClose>
  <div class="dialog-content">
    <i class="icon icon-alert_solid"></i>
    @let t = data?.templateGroup;
    <span>
      {{
        'MANAGEMENT.COMMUNICATION-CENTER.TEMPLATE-GROUP-DELETE-CONFIRMATION'
          | translate
            : {
                name: t?.name,
                referenceCount: t?.referenceCount ?? 0
              }
      }}
    </span>
  </div>
  <div
    class="dialog-footer"
    ngProjectAs="dialog-footer">
    <button
      type="button"
      class="button is-secondary"
      (click)="dialogRef.close(false)">
      {{ 'MANAGEMENT.BUTTONS.CANCEL' | translate }}
    </button>
    <button
      type="button"
      class="button is-danger"
      (click)="dialogRef.close(true)">
      {{ 'MANAGEMENT.COMMUNICATION-CENTER.TEMPLATE-GROUP-DELETE' | translate }}
    </button>
  </div>
</topo-dialog>
